// extracted by mini-css-extract-plugin
module.exports = {"swiperbox":"silder_swiperbox_3S9IM"};